import {
  ClaimEstatesStatusEnum,
  ClaimEstatesStatusLabels
} from '../enums/claim-estates-status.enum';

export interface ClaimEstateStatus {
  index: number;
  value: ClaimEstatesStatusEnum;
  text: string;
}

const buildStatusOption = (
  index: number,
  value: ClaimEstatesStatusEnum
): ClaimEstateStatus => ({
  index,
  value,
  text: ClaimEstatesStatusLabels[value]
});

/** Opções de status usadas em formulários de edição/criação (sem rascunho). */
export const claimEstatesStatusEnum: ClaimEstateStatus[] = [
  buildStatusOption(10, ClaimEstatesStatusEnum.returnBill),
  buildStatusOption(5, ClaimEstatesStatusEnum.debtConfession),
  buildStatusOption(0, ClaimEstatesStatusEnum.created),
  buildStatusOption(6, ClaimEstatesStatusEnum.inAccord),
  buildStatusOption(1, ClaimEstatesStatusEnum.inAnalysis),
  buildStatusOption(2, ClaimEstatesStatusEnum.inProgress),
  buildStatusOption(4, ClaimEstatesStatusEnum.finished),
  buildStatusOption(7, ClaimEstatesStatusEnum.monthlyIndemnity),
  buildStatusOption(8, ClaimEstatesStatusEnum.lmiLmgReached),
  buildStatusOption(3, ClaimEstatesStatusEnum.pending),
  buildStatusOption(9, ClaimEstatesStatusEnum.preAccident)
];

/** Opções de status usadas no filtro da listagem (inclui rascunho). */
export const claimEstatesStatusFilterOptions: ClaimEstateStatus[] = [
  buildStatusOption(11, ClaimEstatesStatusEnum.draft),
  ...claimEstatesStatusEnum
];

export const getClaimEstatesStatusText = (value: string): string => {
  const status = Object.values(ClaimEstatesStatusEnum).includes(
    value as ClaimEstatesStatusEnum
  )
    ? ClaimEstatesStatusLabels[value as ClaimEstatesStatusEnum]
    : undefined;
  return status || 'Status Desconhecido';
};
